document.addEventListener('DOMContentLoaded', function() {
    const clubItems = document.querySelectorAll('.club-item');
    const images = document.querySelectorAll('.one-img-wrap img');

    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
    };

    function handleIntersection(entries) {
        entries.forEach(entry => {
            const index = Array.from(clubItems).indexOf(entry.target);
            
            if (entry.isIntersecting) {
                if (index > 0) {
                    images[index - 1].classList.add('fade-enlarge');
                }
            }
            
            // If the next club-item is in view, remove the class from the previous image
            if (index < clubItems.length - 1 && entry.isIntersecting) {
                images[index].classList.remove('fade-enlarge');
            }
        });
    }

    const observer = new IntersectionObserver(handleIntersection, observerOptions);
    clubItems.forEach(item => observer.observe(item));
});
